module.exports = __webpack_public_path__ + "img/jhsys5.fb84e4e8.png";